/**
 * Client-side helpers for calendar invitations. The records themselves are
 * written by the server (server/api-util/calendarInvites.js); this only reads
 * them for display.
 */

export const INVITE_STATUS = {
  YES: 'yes',
  NO: 'no',
  INVITED: 'invited',
  NOT_SENT: 'notSent',
  NOT_INVITED: 'notInvited',
};

/** What one attendee's record says, as a status the modal can label. */
export const inviteStatusOf = entry => {
  if (!entry) return INVITE_STATUS.NOT_INVITED;
  if (entry.response === 'yes') return INVITE_STATUS.YES;
  if (entry.response === 'no') return INVITE_STATUS.NO;
  if (entry.sentAt) return INVITE_STATUS.INVITED;
  if (entry.skipped) return INVITE_STATUS.NOT_SENT;
  return INVITE_STATUS.NOT_INVITED;
};

/** Totals across every event, for Insights. Mirrors the server's summariseInvites. */
export const summariseInvites = invites => {
  const out = { invited: 0, yes: 0, no: 0, pending: 0, events: 0 };
  Object.values(invites || {}).forEach(forEvent => {
    let any = false;
    Object.values(forEvent || {}).forEach(entry => {
      if (!entry?.sentAt) return;
      any = true;
      out.invited += 1;
      if (entry.response === 'yes') out.yes += 1;
      else if (entry.response === 'no') out.no += 1;
      else out.pending += 1;
    });
    if (any) out.events += 1;
  });
  return out;
};

export const looksLikeEmail = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());

export const normalizeEmail = value =>
  String(value || '')
    .trim()
    .toLowerCase();
